export const en = {
    'label-yav': 'Store tokens, cookies, and other secrets in',
    'link-yav': 'Yandex Secrets',
    title: 'Sensitive data detected'
};
